import { useState, useEffect, useCallback, useRef } from 'react';
import { messageService, DmConversationSummary } from '../services/messageService';

const POLL_INTERVAL_MS = 30_000;

/** Polls the inbox list and unread count, same cadence useNotifications uses — this app has
 * no realtime transport, so this is the ceiling for "near-live" delivery. */
export function useDirectMessages(userId: string | null) {
  const [conversations, setConversations] = useState<DmConversationSummary[]>([]);
  const [loading, setLoading] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const refresh = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    try {
      setConversations(await messageService.getInbox());
    } catch {
      // silently swallow polling errors
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    refresh();
    intervalRef.current = setInterval(refresh, POLL_INTERVAL_MS);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [refresh]);

  const unreadCount = conversations.filter(c => c.hasUnread).length;

  return { conversations, unreadCount, loading, refresh };
}
